import { AppRootState } from '../reducers';

export const buttonBackgroundSelector = (state: AppRootState) =>
  (state.app.entities.resources?.['style.client-backgroundcolor']?.data as any)?.content?.BackgroundClass;
